<template>
  <div data-v-f531b812="" class="app app-ti_green metransRecord">
    <div data-v-8a75a126="" data-v-f531b812="" class="header">
      <div data-v-8a75a126="" class="header__top-wrapper">
        <div data-v-8a75a126="" class="van-nav-bar van-nav-bar--fixed fixed-top rounded-corners nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis">充值信息</div>
          </div>
        </div>
      </div>
    </div>
    <div style="height:40px"></div>
    <div data-v-334775a8="" data-v-f531b812="" class="wrapper green-wrapper">
      <div data-v-334775a8="">
        <div data-v-334775a8="" class="PayInfoTime green-PayInfoTime">
          <div class="PayAmount">
            <span class="Amount">{{ payInfo.info.amount }}</span>
            <span> 元 </span>
          </div>
          <div class="Countdown">
            <div>
              请在<span place="time">{{ m >= 10 ? m : `0${m}` }}：{{ s >= 10 ? s : `0${s}` }}</span>内完成支付
            </div>
          </div>
          <div>成功付款后，将自动到账！</div>
          <div>如有问题，请<span place="thing" class="contact-customer" @click="$parent.openKefu"> 联系客服 </span>确认</div>
        </div>
      </div>

      <div data-v-334775a8="" class="transaction-detail bg">
        <p data-v-334775a8="" v-if="type == 'usdtpay'">
          <span data-v-334775a8=""> 收款地址 </span>
          <span data-v-334775a8="" style="word-break: break-word; max-width: 240px">
            <span data-v-334775a8="" class="transNum paddingSty">{{ payInfo.cardlist.mch_id }}</span>
            <span @click="doCopy(payInfo.cardlist.mch_id)" data-v-334775a8="" class="copy"> 复制 </span>
          </span>
        </p>

        <p data-v-334775a8="">
          <span data-v-334775a8=""> 订单号 </span>
          <span data-v-334775a8="">
            <span data-v-334775a8="" class="transNum paddingSty">{{ payInfo.deposit_no }}</span>
            <span v-if="false" data-v-334775a8="" class="copy"> 复制 </span>
          </span>
        </p>
        <p data-v-334775a8="">交易时间 <span data-v-334775a8="" class="tran-time"> {{ payInfo.info.created_at }} </span></p>
        <p data-v-334775a8="">
          充值方式<span data-v-334775a8="" class="tran-type">{{ payInfo.info.paytype }}</span>
        </p>
        <p data-v-334775a8="" v-if="type =='usdtpay'">
          钱包协议<span data-v-334775a8="" class="tran-type">{{ payInfo.cardlist.content }}</span>
        </p>
        <p data-v-334775a8="" v-if="type =='usdtpay'">
          USDT金额<span data-v-334775a8="" class="tran-type">{{ payInfo.info.real_money }}</span>
        </p>
        <!-- 原有图片 -->
        <img :src="payInfo.cardlist.payimg" style="width:80%;display:block;margin:10px auto" alt="" />

        <!-- 新增：type=usdtpay时显示转账地址输入框 -->
        <p data-v-334775a8="" v-if="type == 'usdtpay'" class="transfer-address-input">
          <span data-v-334775a8=""> 哈希值（交易ID） </span>
          <input
            type="text"
            v-model="transferAddress"
            placeholder="请输入您的哈希值（交易ID）"
            class="transfer-input"
            style="
              width: 100%;
              padding: 8px 12px;
              margin-top: 8px;
              border: 1px solid #e5e7eb;
              border-radius: 4px;
              box-sizing: border-box;
              font-size: 14px;
            "
          />
        </p>
      </div>

      <!-- 底部按钮：根据type切换显示 -->
      <div data-v-334775a8="" class="footer">
        <!-- 非usdtpay时显示原按钮 -->
        <div v-if="type !== 'usdtpay'">
          <div data-v-334775a8="" class="goback-button" @click="$parent.goNav('/transRecord')">
            <img
              data-v-334775a8=""
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAMAAADpVnyHAAAAPFBMVEVHcEwLqoUPqIUPqIYIp4cAr4AOqIYMp4cOp4UNp4UPqIYPqIYPqIYOp4YOqIUPqIYOqIUPp4UNqYYPqIanHmPRAAAAE3RSTlMAMO/wIBBwQIBg0MDfoLCvkOBQvn0j8QAAAJFJREFUGBl1wYkBwiAQBMAlPHdAXrf/XgVJFA3OoOMi/ogTBUM7yYABn1ko7szMSnETJ74ofu08beLQ8xs7c/C4mMRvs6AxE28ULwcHIirLkYgicmRyKMRyIKNyiQOCyi88LSJRV1YZTWCjqJxakg6NWFaKxiQy4OQSC8XJr1xx8QvJgIs/Mj4CafAmREce6MgTIHASgfcpjWAAAAAASUVORK5CYII="
              class="icon"
            /><span data-v-334775a8="">充值完成</span>
          </div>
          <div data-v-334775a8="" class="seedetail-button" @click="$parent.goNav('/transRecord')">
            <img
              data-v-334775a8=""
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAAOVBMVEUMqIcPqIYOqIUOqIYPqIUAr4ALqoVHcEwPp4YOqYcNp4UPqIYPp4UOqIYOqIUIp4cNqYYOqIUPqIbGVSZiAAAAEnRSTlM/0JBw8BAwAMB/YN/goG8gULADspVqAAAAtklEQVQoz42S2xbEEAxFg0hCbzP5/48d2lqL0mnPm2xHboDZL5NeZCwnAW+oA5mdfXX+wEURNWSmCtwpqiRGqj1iyFGAJxZDo1gzaYuUmllpZN/mo7Y9epvvHxvrmZ1v5oBfZZLgR4yOXSLxpYfkMooWHCr6Lp87HH5W2zFRe94xAxarmdGNT7o/UfKd/2VRXKHUyXudAXcD5LKLcn/llPy5JydYzcWl5YYt+QluZplem+8Ye6EfKyMbAQTPPjYAAAAASUVORK5CYII="
              class="icon"
            /><span data-v-334775a8="">资金明细</span>
          </div>
        </div>

        <!-- usdtpay时显示提交按钮（移除内部style标签） -->
        <div v-else data-v-334775a8="" class="submit-button" @click="handleSubmit">
<!--          <img-->
<!--            data-v-334775a8=""-->
<!--            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAMAAADpVnyHAAAAPFBMVEVHcEwLqoUPqIUPqIYIp4cAr4AOqIYMp4cOp4UNp4UPqIYPqIYPqIYOp4YOqIUPqIYOqIUPp4UNqYYPqIanHmPRAAAAE3RSTlMAMO/wIBBwQIBg0MDfoLCvkOBQvn0j8QAAAJFJREFUGBl1wYkBwiAQBMAlPHdAXrf/XgVJFA3OoOMi/ogTBUM7yYABn1ko7szMSnETJ74ofu08beLQ8xs7c/C4mMRvs6AxE28ULwcHIirLkYgicmRyKMRyIKNyiQOCyi88LSJRV1YZTWCjqJxakg6NWFaKxiQy4OQSC8XJr1xx8QvJgIs/Mj4CafAmREce6MgTIHASgfcpjWAAAAAASUVORK5CYII="-->
<!--            class="icon"-->
<!--          />-->
          <span data-v-334775a8="">提交转账信息</span>
        </div>
      </div>
      <!---->
    </div>

    <div data-v-f531b812="" class="float-divbox"></div>
    <span data-v-7b0f8a3e="" data-v-f531b812="" class="customer-service-container"></span><span data-v-f531b812=""></span>
    <div data-v-55ec3770="" data-v-f531b812="" class="select-service-line-view select-service-line-view">
      <dl data-v-55ec3770="" class="select-service-list"><div data-v-55ec3770="" style="height: 55px"></div></dl>
    </div>
  </div>
</template>
<script>
export default {
  name: 'payInfo',
  data() {
    return {
      payInfo: {},
      type: null,
      daoTime: null,
      m: 0,
      s: 0,
      transferAddress: '', // 存储用户输入的转账地址
      timer: null // 定时器变量，避免内存泄漏
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.deposit_no) {
      that.getpayinfo(query.deposit_no);
    }
  },
  methods: {
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$parent.showTost(1, '复制成功！');
      document.body.removeChild(cInput); // 复制后移除临时输入框
    },
    getpayinfo(deposit_no) {
      let that = this;
      this.$parent.showLoading();
      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.payInfo = res.data;
          that.type = res.message;
          that.countTime();
        }
        this.$parent.hideLoading();
      });
    },
    countTime() {
      let that = this;
      var date = new Date();
      var now = date.getTime();
      let created_at = that.payInfo.info.created_at;
      let createdTime = new Date(created_at).getTime();
      var end = createdTime + 1000 * 60 * 60; // 1小时倒计时
      var leftTime = end - now;

      if (leftTime >= 0) {
        that.m = Math.floor((leftTime / 1000 / 60) % 60);
        that.s = Math.floor((leftTime / 1000) % 60);
      } else {
        clearTimeout(that.timer);
        that.timer = null;
        return;
      }
      // 用timer变量存储定时器，避免重复创建
      that.timer = setTimeout(this.countTime, 1000);
    },
    // 提交转账地址逻辑
    handleSubmit() {
      // 1. 基础验证：转账地址不能为空
      if (!this.transferAddress.trim()) {
        this.$parent.showTost(0, '请输入您的哈希值（交易ID）');
        return;
      }

      // 2. 提交逻辑（根据实际接口调整）
      this.$parent.showLoading();
      this.$apiFun.post('/api/transferAddress', {
        deposit_no: this.payInfo.deposit_no, // 订单号
        transfer_address: this.transferAddress, // 用户输入的转账地址
        pay_type: 'usdtpay' // 支付类型
      }).then(res => {
        this.$parent.hideLoading();
        if (res.code == 200) {
          this.$parent.showTost(1, '转账信息提交成功，等待确认');
          // 提交成功后跳转至交易记录页
          setTimeout(() => {
            this.$parent.goNav('/transRecord');
          }, 1500);
        } else {
          this.$parent.showTost(0, res.message || '提交失败，请重试');
        }
      }).catch(err => {
        this.$parent.hideLoading();
        this.$parent.showTost(0, '网络异常，请重试');
        console.error('提交失败：', err);
      });
    }
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
};
</script>
<style lang="scss" scoped>
@import '../../static/css/fund-recharge-info.dba269b9.css';

/* 1. 转账地址输入框样式 */
.transfer-address-input {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  span {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}

/* 2. 提交按钮样式（原内联样式移到这里） */
.submit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  background-color: #00b42a; /* 沿用绿色主题 */
  color: #fff;
  border-radius: 8px;
  margin: 0 10px;
  cursor: pointer;
  font-size: 16px;
  .icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}

/* （可选）如果原footer按钮有间距，可补充样式保持对齐 */
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 16px; /* 按钮之间的间距 */
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue